import _ from "lodash";

export class Språk {

    tags: string[];
    /** tilsvarer serversidens no.systemfabrikken.lederplan.tjenester.i18n.I18nStøttedeSpråk.Språk */
    servertag: string;
    beskrivelse: string;
    ikon: string;
    standard: boolean;
    land:string

    constructor(tags, servertag, beskrivelse, ikon, land, standard?: boolean) {
        this.tags = tags;
        this.servertag = servertag;
        this.beskrivelse = beskrivelse;
        this.ikon = ikon;
        this.land = land;
        this.standard = standard || false;
    }

    harTag(tag: string) {
        return _(this.tags).includes(tag);
    }

    private static _tilgjengeligSpråk: Språk[] = [
        new Språk(["no", "nb"], "nb", 'Norsk', null,'NO', true),
        new Språk(["nn"], "nn", 'Nynorsk', null, 'NO'),
        new Språk(["en"], "en", 'English', null, 'GB')
    ];

    static tilgjengeligSpråk(): Språk[] {
        return Språk._tilgjengeligSpråk;
    }

    /** Norsk / nb */
    static standardSpråk(): Språk{
        return Språk.tilgjengeligSpråk().filter(s => s.standard)[0];
    }

    /** Finner Språk basert på {@link Språk#tags}, null dersom ingen med angitt tag funnet. */
    static finnSpråkFraTag(tag): Språk {
        return _(Språk.tilgjengeligSpråk()).find((s) => s.harTag(tag));
    }

    static finnSpråkFraTagsEllerStandard(tags: string[]): Språk {
        const tilgjengeligSpråk = _(tags).map((tag) => Språk.finnSpråkFraTag(tag)).value()[0];
        return tilgjengeligSpråk ? tilgjengeligSpråk : Språk.standardSpråk();
    }

}
